import { render, staticRenderFns } from "./setAnswerAnalysis.vue?vue&type=template&id=cf2933a0&scoped=true&"
import script from "./setAnswerAnalysis.vue?vue&type=script&lang=js&"
export * from "./setAnswerAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./setAnswerAnalysis.vue?vue&type=style&index=0&id=cf2933a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2933a0",
  null
  
)

export default component.exports